<template>
	<section class="setting">
		<Nav title="设置" />
		<div class="num">
			<p>版本号</p>
			<p>{{version}}</p>
		</div>
		<div class="bottom">
			<van-button type="primary" @click="loginOutFn">退出登录</van-button>
		</div>
	</section>
</template>

<script>
import Nav from "components/Nav"
import loginServer from "api/login";

export default {
	name: 'setting',
	components: {
		Nav,
	},
	data() {
		return {
			version: this.$store.state.versionData.versionNumber
		}
	},
	mounted() {
	},
	methods: {
		loginOutFn() {
			loginServer.LoginOut().then(() => {
				localStorage.removeItem("token")
				localStorage.removeItem("position")
				localStorage.removeItem("code")
				localStorage.removeItem("position_error")
				this.$router.push({ name: 'user'})
			})
			
		},
	}
}
</script>

<style lang="scss">
	.setting {
		padding-top: 46px;
		.num {
			padding-top: 193px;
			text-align: center;
			p {
				color: #7D8290;
				font-size: 15px;
				margin-bottom: 4px;
			}
		}
		.bottom{
			margin: 0 auto;
			width: 200px;
			background: #3A5EEC;
			border-radius: 50px;
			overflow: hidden;
			margin-top: 40px;
			.van-button--primary {
				width: 100%;
				height: 40px;
				border: 0;
				font-size: 16px;
				font-weight: bold;
				color: #fff;
				border-radius: 0;
				

			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/user/setting/Setting.vue